import { fg } from '@atlassian/jira-feature-gating';

const getForgeQuery = () =>
	`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;

export const getEcosystemQuery = (includeForgeQuery = true): string =>
	`
    ecosystem {
      ${
				fg('remove-issueviewinteractivequery-m4')
					? ''
					: `activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }`
			}
       ${
					fg('remove-issueviewinteractivequery-m4')
						? ''
						: `contextPanels {
            name
            iframe {
              addonKey
              moduleKey
              options
            }
            icon {
              url
            }
            content
            status
            type
          }`
				}
      ${includeForgeQuery ? getForgeQuery() : ''}
    }
`;

export const getLegacyRightWebPanelsQuery = (): string => `
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;
